module.exports = __webpack_public_path__ + "img/ico-10.43916a37.svg";